import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef(({ className, sideOffset = 8, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-[200] overflow-hidden rounded-md px-3 py-1.5 text-[13px] font-medium text-white",
        "shadow-lg shadow-black/40",
        "animate-in fade-in-0 zoom-in-95",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        "reduce-motion:animate-none reduce-motion:data-[state=closed]:animate-none",
        className
      )}
      style={{
        backgroundColor: "#14141A",
        border: "1px solid rgba(168, 85, 247, 0.25)",
        maxWidth: "280px",
      }}
      {...props}
    >
      {props.children}
      <TooltipPrimitive.Arrow
        className="fill-[#14141A]"
        style={{ filter: "drop-shadow(0 1px 0 rgba(168, 85, 247, 0.2))" }}
      />
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
